import { render, staticRenderFns } from "./pieGroup.vue?vue&type=template&id=0457376b&scoped=true&"
import script from "./pieGroup.vue?vue&type=script&lang=js&"
export * from "./pieGroup.vue?vue&type=script&lang=js&"
import style0 from "./pieGroup.vue?vue&type=style&index=0&id=0457376b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457376b",
  null
  
)

export default component.exports